/* eslint-disable */
const state = {
  accountTransactions: [],
  cashierTransactions: [],
  accounts: [],
  transactionCategories: [],
}
export default state
